module.exports = __webpack_public_path__ + "img/5stars.d7bb8e82.png";